import { type ReactNode, type RefObject, useRef } from 'react';
import { useIntersectionObserver } from 'shared/hooks/useIntersectionObserver';

type ActionAfterViewObserverProps<T extends HTMLElement> = {
  children: ({ elementRef }: { elementRef: RefObject<T> }) => ReactNode;
  callback: () => void;
};

export const ActionAfterViewObserver = <T extends HTMLElement = HTMLElement>({
  children,
  callback,
}: ActionAfterViewObserverProps<T>): ReturnType<ActionAfterViewObserverProps<T>['children']> => {
  const elementRef = useRef<T>(null);

  useIntersectionObserver({
    elementRef,
    onInViewport: ({ subscribeState }) => {
      subscribeState.setSubscribeUnavailable();

      callback();
    },
  });

  return children({ elementRef });
};
